<template>
	<img class="sticker" v-if="sticker" :src="sticker">
</template>

<script>

import { stickers } from "@/network/productRequests";

export default {
	name: 'ProductSticker',
	props: ["stickerId"],
	components: {

	},
	computed: {
		sticker() {
		let baseUrl = "/resources/images/ui/";
		if (this.stickerId && this.stickerId) {
			let sticker = stickers[this.stickerId]
			if (sticker != "none" && sticker != "info-product" && sticker != 'discount-partner'){
				return baseUrl + sticker + '-sticker.png';
			}
		}
		return null;
		}
	}
}
</script>

<style lang="scss" scoped>
	.sticker {
		position: absolute;
		// top: 0;
		// left: 0;
		bottom: 0;
		right: 0;
		z-index: 199;
		width: 70px;
	}
</style>